.flash-banner-cta-container {
    /* This makes sure our link won't wrap to another line */
    width: 126px;
    display: flex;
    align-items: center;
    margin-left: 16px;
}
